module.exports = __webpack_public_path__ + "static/media/FlyBirdsBox_RoseGold_Icons-instagram.f25e5319.png";